const initialState = {
  accountPerformedRegistration: '',
  registrationResponse: '',
  showRegistrationNote: false,
  isMissingCatalog: false,
  accountNeedToResubmit: false,
  shownEditView: false,
  bulkSmsFeatureEnabled: false,
  mainAccountRegistrationResponse: '',
  showRequiredChanges: false,
  reRegister:false,
  bulkSmsCampaign: null,
  fetchingBulkSmsCampaign: false,
  bulkSmsCampaignNumbers: [],
  followerAccount:false,
  numberOfFollowers: [],
  registrationError: null,
  soleProprietorEnabled: false,
  soleProprietorEditEnabled: false,
  isVoluntaryEditEnabled: false,
  sinchApprovalPending: false,
};

export default initialState;
